import {api} from "@/lib/inner";

const toKey = b64 => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
};
const supported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const registration = () => navigator.serviceWorker.register("/sw.js").then(() => navigator.serviceWorker.ready);

export async function pushState() {
  if (!supported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  const sub = await (await registration()).pushManager.getSubscription();
  return sub ? "on" : "off";
}

export async function enablePush(save) {
  if ((await Notification.requestPermission()) !== "granted") return "denied";
  const reg = await registration();
  const key = (await api.get("/push/public-key")).data.public_key;
  const sub = (await reg.pushManager.getSubscription()) || (await reg.pushManager.subscribe({userVisibleOnly: true, applicationServerKey: toKey(key)}));
  await save(sub.toJSON());
  return "on";
}

export async function disablePush(remove) {
  const sub = await (await registration()).pushManager.getSubscription();
  if (sub) { await remove(sub.toJSON()); await sub.unsubscribe(); }
  return "off";
}
